'use client'

import { useCallback, useEffect, useState } from 'react'
import { v7 as uuid } from 'uuid'

const generateIds = (count: number): string[] =>
  Array.from({ length: count }, () => uuid())

type UseEmptyRowIdsResult = {
  ids: string[]
  refresh: () => void
}

/**
 * Manages a set of stable empty-row IDs that can be regenerated after a row is
 * created from one of the placeholders. Call `refresh()` inside
 * `onCellValueChanged` when the edited row was a placeholder (`isNewRowId`).
 */
export function useEmptyRowIds(count: number): UseEmptyRowIdsResult {
  const [ids, setIds] = useState<string[]>(() => generateIds(count))

  useEffect(() => {
    setIds((prev) => {
      if (prev.length === count) return prev
      return generateIds(count)
    })
  }, [count])

  const refresh = useCallback(() => {
    setIds(generateIds(count))
  }, [count])

  return { ids, refresh }
}
